<template>
  <div class="details-container">
    <div class="details-list" v-if="detailsName && detailsName.length > 0">
      <div v-for="(detail, index) in detailsName" :key="index" class="detail-item">
        <div class="detail-number">{{ index + 1 }}</div>

        <div class="detail-content">
          <div class="detail-name">
            {{ detail.name }}
          </div>
        </div>

        <div class="detail-actions" @click.stop>
          <button v-if="validaToSave(detail)" @click="bvSave(detail)" class="btn btn-sm btn-outline-success"
            v-b-tooltip.hover.top="'Зберегти'">
            <i class="far fa-save"></i>
          </button>
          <button class="btn btn-sm btn-outline-danger" @click="remove(index)" v-b-tooltip.hover.top="'Видалити'">
            <i class="far fa-trash-alt"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="details-empty">
      <div class="add-detail-button" v-b-modal.modal-name-add>
        <div class="add-button-content">
          <i class="fas fa-plus"></i>
          <span>Додати виріб</span>
        </div>
      </div>
    </div>

    <b-modal id="modal-name-add" title="Додати виріб" @show="resetModal" @hidden="resetModal" @ok="handleOk"
      ok-title="Додати" cancel-title="Скасувати" hide-header-close :dialog-class="'modal-dialog-v2'"
      :content-class="'modal-content-v2'" :header-class="'modal-header-v2'" :title-class="'modal-title-v2'"
      :body-class="'modal-body-v2'" :footer-class="'modal-footer-v2'">

      <template #modal-header="{ close }">
        <h5 class="modal-title-v2 m-0">Додати виріб</h5>
        <button type="button" class="close close-v2" aria-label="Close" @click="close()">
          <i class="fa fa-times"></i>
        </button>
      </template>

      <form ref="form" @submit.stop.prevent="handleSubmit">
        <input id="name-input" v-model="detailName" :class="['simple-input-v2', nameState === false ? 'error' : '']"
          type="text" placeholder="Введіть назву виробу" required>
        <div v-if="nameState === false" class="error-message">
          {{ nameStateErrorText }}
        </div>
      </form>

      <template #modal-footer="{ ok, cancel }">
        <button type="button" class="btn btn-secondary" @click="cancel()">Скасувати</button>
        <button type="button" class="btn btn-primary" @click="handleSubmit">Додати</button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import { productService } from "../../services/productService";

export default {
  name: "DetailsNameTable",
  props: ['detailsName'],
  data() {
    return {
      detailName: "",
      nameState: null,
      nameStateErrorText: "",
    }
  },
  methods: {
    checkFormValidity() {
      let valid = this.$refs.form.checkValidity();
      const exists = this.detailsName.filter(detail => detail.name == this.detailName)

      if (!valid) {
        this.nameStateErrorText = 'Назва обов\'язкова'
      }
      if (exists.length > 0) {
        valid = false;
        this.nameStateErrorText = 'Такий виріб вже існує'
      }
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.detailName = '';
      this.nameStateErrorText = '';
      this.nameState = null;
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.handleSubmit()
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return
      }
      this.detailsName.push({ id: null, name: this.detailName })

      this.$nextTick(() => {
        this.$bvModal.hide('modal-name-add')
      })
    },
    remove(i) {
      let nameItem = this.detailsName[i];
      app.details.forEach((el) => {
        if (el.name === nameItem.name) el.name = '';
      })
      this.$store.commit('data/REMOVE_NAME', i);
    },
    processSimilarName(currentDetail, key) {

      let oldList = Object.keys(this.detailsName).filter(item => item != key);
      let finded = oldList.filter(detail => this.detailsName[detail].name == currentDetail.name);

      if (finded.length > 0) {

        this.$store.commit('data/SET_DETAILS', this.$store.state.data.details.map((item) => {
          if (this.detailsName.filter(detail => detail.name === item.detail_name && item.detail_name.length > 0).length === 0) {
            item.detail_name = currentDetail.name;
          }
          return item;
        }));
        this.detailsName.splice(key, 1);
      }
    },
    bvSave(detail) {

      productService.existsProduct(detail.name, detail?.id).then(result => {
        if (result.data.exists) {
          this.$bvModal.msgBoxConfirm('Ви впевнені, що хочете перезаписати існуючий виріб?', {
            title: 'Підтвердіть',
            size: 'mm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Так',
            cancelTitle: 'Ні',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
            .then((value) => {
              if (value) {
                detail.id = result.data.id
                this.save(detail);
              }
            })
        } else {
          this.save(detail);
        }
      })

    },
    save(detail) {
      if (this.loading) return;
      let details = this.$store.state.data.details.filter((item) => item.name === detail.name);
      this.loading = true;

      // Получаем материалы и кромки из store
      const materials = this.$store.state.data.materials;
      const edges = this.$store.state.data.edges;
      const defaultMaterial = this.$store.getters['data/defaultMaterial'];
      const defaultEdge = this.$store.getters['data/defaultEdge'];

      // Получаем уникальные ref'ы материалов, используемых в деталях
      const usedMaterialRefs = [...new Set(details.map(item => item.material).filter(Boolean))];
      const usedEdgeRefs = [...new Set([
        ...details.map(item => item.edge_t),
        ...details.map(item => item.edge_l),
        ...details.map(item => item.edge_r),
        ...details.map(item => item.edge_b),
        ...details.map(item => item.edge_template)
      ].filter(Boolean))];

      let data = {
        "customer": this.$store.state.auth.user.client.ref,
        "name": detail.name,
        "customer_material": this.$store.state.data.order?.customer_material || false,
        "customer_edge": this.$store.state.data.order?.customer_edge || false,
        "glue": this.$store.state.data.order?.glue || false,
        "edge_size": this.$store.state.data.order?.edge_size || false,
        "materials_list": materials
          .filter(m => usedMaterialRefs.includes(m.ref))
          .map(item => ({
            ref: item.ref,
            color: item.color,
            default: item.ref === defaultMaterial?.ref
          })),
        "edge_list": edges
          .filter(e => usedEdgeRefs.includes(e.ref))
          .map(item => ({
            ref: item.ref,
            color: item.color,
            default: item.ref === defaultEdge?.ref
          })),
        "screed_list": [...new Set(details.map(item => item.screed))],
        "items": details,
      };
      this.$toast.success("Вже робимо");
      if (detail.id !== null && detail.id !== undefined) {
        productService.updateProduct(detail.id, data).then(response => {
          detail.id = response.product.id;
          this.$toast.success("Успішно оновлено");
        }).then(r => {
          this.loading = false;
        }).catch(e => {
          this.loading = false;
          this.$toast.error("Щось пішло не так =(");
        })
      } else {
        productService.createProduct(data).then(response => {
          detail.id = response.product.id;
          this.$toast.success("Успішно збережено");
        }).then(r => {
          this.loading = false;
        }).catch(e => {
          this.loading = false;
          this.$toast.error("Щось пішло не так =(");
        });
      }

    },
    validaToSave(detail) {
      let details = this.$store.state.data.details.filter((item) => item.name === detail.name);
      return details.length > 0 && detail.name.length > 0;
    }
  },
  mounted() {
    this.$root.$on('update', i => {
      this.$forceUpdate();
    });
  }
}
</script>

<style scoped>
/* Стили в том же стиле что и MaterialsTable.vue */
.details-container {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 10px;
  width: 100%;
}

.details-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #dee2e6;
}

.details-title {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 6px;
}

.details-title i {
  color: #2c5aa0;
  font-size: 0.8rem;
}

.details-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-item {
  display: flex;
  align-items: center;
  background: white;
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
  gap: 8px;
  min-height: 40px;
}

.detail-item:hover {
  background: #f8f9fa;
  border-color: #19469e;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.detail-number {
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  min-width: 20px;
  text-align: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.detail-content {
  flex: 1;
  min-width: 0;
}

.detail-name {
  font-weight: 500;
  font-size: 0.85rem;
  cursor: default;
  word-wrap: break-word;
  word-break: break-word;
  line-height: 1.3;
  color: #495057;
}

.detail-actions {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
}

.details-empty {
  margin-top: 5px;
  text-align: center;
  color: #6c757d;
}

.details-empty i {
  margin-right: 6px;
}

/* Add Detail Button */
.add-detail-button {
  border: 2px dashed #2c5aa0;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(44, 90, 160, 0.02);
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-detail-button:hover {
  background: rgba(44, 90, 160, 0.08);
  border-color: #1e4a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.15);
}

.add-button-content {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  color: #2c5aa0;
}

.add-button-content i {
  font-size: 1.5rem;
  color: #2c5aa0;
  margin: 0;
}

.add-button-content span {
  font-size: 0.9rem;
  font-weight: 500;
  color: #2c5aa0;
}

/* Bootstrap button overrides - точно как в MaterialsTable */
.btn-sm {
  padding: 3px 6px;
  font-size: 0.7rem;
}

.btn-primary {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
}

.btn-primary:hover {
  background-color: #1e4a8a;
  border-color: #1e4a8a;
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}

.btn-outline-success {
  color: #28a745;
  border-color: #28a745;
}

.btn-outline-success:hover {
  background-color: #28a745;
  border-color: #28a745;
  color: white;
}

/* Modal v2 Styles (aligned with search.vue) */
.modal-dialog-v2 {
  max-width: 520px;
}

.modal-content-v2 {
  border-radius: 10px;
  border: 1px solid #e1e4e8;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.modal-header-v2 {
  padding: 18px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
}

.modal-title-v2 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.05rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.modal-body-v2 {
  padding: 20px;
  background: #fff;
}

.simple-input-v2 {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  font-size: 0.9rem;
  background: white;
  transition: all 0.3s ease;
  outline: none;
}

.simple-input-v2:focus {
  border-color: #2c5aa0;
  box-shadow: 0 0 0 3px rgba(44, 90, 160, 0.1);
}

.simple-input-v2::placeholder {
  color: #656d76;
}

.simple-input-v2.error {
  border-color: #d73a49;
}

.simple-input-v2.error:focus {
  border-color: #d73a49;
  box-shadow: 0 0 0 3px rgba(215, 58, 73, 0.1);
}

.error-message {
  color: #d73a49;
  font-size: 0.875rem;
  margin-top: 8px;
}

.modal-footer-v2 {
  padding: 14px 20px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}

.modal-footer-v2 .btn {
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.modal-footer-v2 .btn-primary {
  background: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
}

.modal-footer-v2 .btn-primary:hover {
  background: #19469e;
  border-color: #19469e;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.modal-footer-v2 .btn-secondary {
  background: white;
  border-color: #e9ecef;
  color: #495057;
}

.modal-footer-v2 .btn-secondary:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
  color: #495057;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Close button v2 */
.close-v2 {
  background: transparent;
  border: none;
  color: #6c757d;
  padding: 6px;
  line-height: 1;
  cursor: pointer;
}

.close-v2:hover {
  color: #343a40;
}
</style>

<style>
/* Global overrides for teleported BootstrapVue modal */
.modal-title-v2 {
  color: #ffffff !important;
}
</style>